import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { VaccinConsultationItem } from 'src/app/entities/consultation.entity';
import { DoctorVaccinationsService } from 'src/app/services/doctor-vaccinations.service/doctor-vaccination.service';
import { VaccinFilter } from '../../vaccination-from.module/vaccin-select-drawer.component/vaccin-select-drawer.component';


export class ConsultationItemValidation {
  controlsValidation: Record<symbol, symbol | null> = {}
  get isValid(): boolean {
    return Array.from(Object.values(this.controlsValidation)).every(elm => elm === null)
  }
}

export class VaccinConsultationnItemValidation extends ConsultationItemValidation {
  controlsValidation: { vaccin: 'required' | null, date: 'required' | 'number' | 'min' | null } = {
    vaccin: null,
    date: null
  };
  constructor(controlsValidation: {vaccin: 'required' | null, date: 'required' | 'number' | 'min' | null }) {
    super()
    this.controlsValidation = controlsValidation
  }

  get isValid(): boolean {
    return Array.from(Object.values(this.controlsValidation)).every(elm => elm === null)
  }
}
@Component({
  selector: 'app-vaccin-consultation-forms',
  templateUrl: './consultation-vaccination-form.component.html',
  styleUrls: ['./consultation-vaccination-form.component.css']
})
export class ConsultationVaccinationFormComponent implements OnInit {

  @Input() vaccinesConsultationItems: Array<VaccinConsultationItem> = new Array();
  @Output() vaccinesConsultationItemsChange: EventEmitter<Array<VaccinConsultationItem>> = new EventEmitter();
  @Output() validation: EventEmitter<boolean> = new EventEmitter()

    vaccinfilter: Array<VaccinFilter> = new Array({ vaccinConsultation: new VaccinConsultationItem({}), selected: false ,index:0});
  drawerActive: boolean = false;

  @Input() set submitted(v: boolean) {
    this._submitted = v;
    this.vaccinesConsultationItems = this.vaccinesConsultationItems.filter(e => e.vaccin != null && e.vaccin.id_Vaccin != null && e.vaccin.id_Vaccin.length > 0)
    this._change()
  }
  vaccines: Array<any> = new Array();
  private _submitted: boolean = false;
  get submitted(): boolean {
    return this._submitted;
  }

  get isValid(): boolean {
    return this.vaccinesConsultationItems.every(item => this.validateConsultationItem(item).isValid)
  }
  constructor(private doctorVaccinationsService: DoctorVaccinationsService, private toasterService: ToastrService) { }

  get groupedvaccines(): Array<{ keyName: string, items: Array<{ label: string, id: string }> }> {
    let groups: Array<string> = Array.from(this.vaccines, r => r.nom_Labo_Vaccin)
    return Array.from(groups, group => {
      let items: Array<{ label: string, id: string }> = new Array();
      this.vaccines.forEach(vaccin => {
        if (group == vaccin.nom_Labo_Vaccin) items.push({ label: vaccin.nom_Vaccin, id: vaccin.id_Vaccin });
      })
      return {
        keyName: group, items: items
      };
    });
  }

  ngOnInit(): void {
    this.allvaccines()
  }
allvaccines(): void {
      this.doctorVaccinationsService.all().subscribe(res => { this.vaccines = res; }, error => this.toasterService.error('Enable to load vaccines'))

}
  addConsultationVaccinationItem(): void {
    let vaccinConsultationItem: VaccinConsultationItem = new VaccinConsultationItem({});
    //vaccinConsultationItem.vaccin = null as any;
    this.vaccinesConsultationItems.push(vaccinConsultationItem);
    this._change()
  }

  deletePrescriptionItem(index: number): void {
    this.vaccinesConsultationItems.splice(index, 1);
  }

  validateConsultationItem(vaccinConsultationItem: VaccinConsultationItem): VaccinConsultationnItemValidation {
    return vaccinConsultationItem.vaccin && vaccinConsultationItem.vaccin.id_Vaccin && vaccinConsultationItem.vaccin.id_Vaccin.length > 0 ? new VaccinConsultationnItemValidation({
      vaccin: null,
      date: vaccinConsultationItem.date_consultation_vaccin ? (!isNaN(Number(vaccinConsultationItem.date_consultation_vaccin)) ? (Number(vaccinConsultationItem.date_consultation_vaccin) < 1 ? 'min' : null) : 'number') : 'required'
    }) : new VaccinConsultationnItemValidation({ vaccin: null, date: null });
  }

  onEditPrescriptionItem(index: number): void {
    this._change()
  }
  closed(): void {
    this.vaccinfilter.map((elm:any) => {

      return this.vaccinesConsultationItems.push(new VaccinConsultationItem({ vaccin: elm.vaccinConsultation.vaccin }));
    });
    // Étape 1: Utiliser reduce pour compter les occurrences des objets biologie
    const countvaccine = this.vaccinfilter.reduce((acc, obj) => {
      const vaccineKey = JSON.stringify(obj.vaccinConsultation.vaccin);
      acc[vaccineKey] = (acc[vaccineKey] || 0) + 1;
      return acc;
    }, {});

    // Étape 2: Utiliser filter pour sélectionner les objets dont biologie apparaît plus d'une fois
    const vaccines = this.vaccinfilter.filter((obj, index, self) => {
      const vaccineKey = JSON.stringify(obj.vaccinConsultation.vaccin);
      return (
        countvaccine[vaccineKey] > 1 &&
        self.findIndex((o) => this.deepEqual(o.vaccinConsultation.vaccin, obj.vaccinConsultation.vaccin)) === index
      );
    });


    this.vaccinfilter = vaccines;
    const countvaccineItem = this.vaccinesConsultationItems.reduce((acc, obj) => {
      const vaccineKey = JSON.stringify(obj.vaccin);
      acc[vaccineKey] = (acc[vaccineKey] || 0) + 1;
      return acc;
    }, {});

    // Étape 2: Utiliser filter pour sélectionner les objets dont biologie apparaît plus d'une fois
    const vaccinesitem = this.vaccinesConsultationItems.filter((obj, index, self) => {
      const vaccineKey = JSON.stringify(obj.vaccin);
      return (
        countvaccineItem[vaccineKey] > 1 &&
        self.findIndex((o) => this.deepEqual(o.vaccin, obj.vaccin)) === index
      );
    });
    this.vaccinesConsultationItems = this.vaccinesConsultationItems.filter(elm => elm.vaccin.nom_Vaccin !== "")
    this.drawerActive = false;
  }
  deepEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
  _change() {
    this.vaccinesConsultationItemsChange.emit(this.vaccinesConsultationItems)
    this.validation.emit(this.isValid);
        this.allvaccines()

  }
}
